export default __webpack_public_path__ + "static/media/bright_farmer.07058282.png";